import moment from 'moment';

import JInspectorRow from '../../../../components/shared/JInspectorComponents/JInspectorRow';

const STATE_OPTIONS = [
    { label: 'Active', value: 0 },
    { label: 'Completed', value: 1 },
    { label: 'Hidden', value: 2 },
    { label: 'Deleted', value: 999 },
];

export default function GroupSettingsMeta({ form, group, onChange }) {
    return (
        <div id="group-settings-meta">
            <div className="yns-section-label">Meta Data</div>
            <div className="j-inspector-row">
                <span className="j-tooltip-label">Goal</span>
                <textarea
                    className="j-inspector-select yns-textarea"
                    value={form.goal || ''}
                    onChange={(e) => onChange('goal', e.target.value)}
                    maxLength={500}
                    rows={2}
                />
            </div>
            <div className="j-inspector-row">
                <span className="j-tooltip-label">Tag</span>
                <input
                    className="j-inspector-select"
                    value={form.tag || ''}
                    onChange={(e) => onChange('tag', e.target.value)}
                    maxLength={50}
                />
            </div>
            <JInspectorRow label="State" value={form.stateId ?? 0} options={STATE_OPTIONS} onChange={(v) => onChange('stateId', v)} />

            <div className="yns-section-label">Identity</div>
            <JInspectorRow label="RK" value={group.rk} readonly />
            <JInspectorRow label="Created" value={group.ems ? moment(group.ems).format('YYYY-MM-DD HH:mm') : '—'} readonly />
        </div>
    );
}
